import { COUNTRIES } from '@cdaas/reusable-components-daas';

export const ORDER_FLOW_CONSTANTS = {
  selectProduct: 'select-product',
  bundle: 'bundle',
  checkoutDetails: 'checkout-details',
  deliveryOptions: 'delivery-options',
  orderCompleted: 'order-completed',
};

export const COUNTRY_OPTIONS: { value: string; countryName: string; available: boolean }[] = COUNTRIES.map(cc => {
  const availableCountries = ['NO', 'FI', 'SE'];
  const available = availableCountries.includes(cc.value);
  return {
    value: cc.value,
    countryName: cc.countryName,
    available,
  };
});

export const DATE_AND_TIME_FORMAT = 'dd.LL.yyyy HH:mm';
export const ASSET_MAX_LIMIT = 32000; // Use limit to get all assets

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const EMAIL_OR_EMPTY_STRING_REGEX = /^$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const HIDDEN_PAGE_PATHS = {
  orders: '/issues-overview', // Keep old path for now
  returnPackageOrders: '/return-package-orders',
  devices: '/devices',
  availability: '/availability',
  reports: '/reports',
};
